export const styles = {
  tableContainer: 'w-full rounded relative table border border-gray-200 divide-y divide-gray-200',
  PhotoTableCont:"w-full rounded relative",
  tableHeader: 'flex items-center w-full px-4 bg-blueGray-50 capitalize h-14 text-sm',
  tableRow: 'flex w-full px-4 py-3',
  tableCell: 'px-4 flex items-center truncate',
};
